import React from 'react';

import { constants, formatMailtoContent, locale } from '@trqk/utils';

const { TRIAL_HELP_EMAIL_ADDRESS } = constants;

/**
 * Warns a user that an invitation is required to create an account, and exposes a mailto: link
 * they can use to request support if they think they have an invitation.
 * @param {ToastRenderContentProps<{ email: string }>} props
 */
export const InvitationRequiredToast = ({
    input,
}: ToastRenderContentProps<{ email: string }>): JSX.Element => {
    const email = input?.email ?? 'unknown';
    const mailtoContent = formatMailtoContent({
        email: TRIAL_HELP_EMAIL_ADDRESS,
        subject:
            locale.enUS.SIGN_UP.TOASTS.INVITATION_REQUIRED.EMAIL_CONTENT
                .SUBJECT,
        bodyLines: [
            locale.enUS.SIGN_UP.TOASTS.INVITATION_REQUIRED.EMAIL_CONTENT
                .GREETING,
            `${locale.enUS.SIGN_UP.TOASTS.INVITATION_REQUIRED.EMAIL_CONTENT.BODY_PART_1} ${email}`,
            locale.enUS.SIGN_UP.TOASTS.INVITATION_REQUIRED.EMAIL_CONTENT
                .BODY_PART_2,
            locale.enUS.SIGN_UP.TOASTS.INVITATION_REQUIRED.EMAIL_CONTENT
                .SIGN_OFF,
        ],
    });

    return (
        <div style={{ width: 300 }} className="px-2 text-sm">
            <div className="flex justify-between items-start mb-4">
                <div className="font-bold text-highlight-orange tracking-wider">
                    {locale.enUS.SIGN_UP.TOASTS.INVITATION_REQUIRED.TITLE}
                </div>
            </div>

            <div className="mb-2">
                {locale.enUS.SIGN_UP.TOASTS.INVITATION_REQUIRED.DESCRIPTION}
            </div>
            <div className="mb-2">
                {
                    locale.enUS.SIGN_UP.TOASTS.INVITATION_REQUIRED
                        .EMAIL_FOR_SUPPORT
                }
                &nbsp;
                <a className="text-primary-500 underline" href={mailtoContent}>
                    {TRIAL_HELP_EMAIL_ADDRESS}
                </a>
                .
            </div>
        </div>
    );
};
